import React, { memo } from 'react'

import { useHostnameRootUrl, useHandler } from '@surglogs-app/hooks'
import { Button } from '@surglogs-app/ui'

import { useTranslation } from '../services'

export const ErrorScreenBackButton = memo(
  ({ isAuthorized }: { isAuthorized: () => boolean }) => {
    const { t } = useTranslation()

    const url = useHostnameRootUrl()

    const onClick = useHandler(() => {
      if (isAuthorized()) {
        return window.history.replaceState(null, '', '/')
      }

      window.location.href = url
    })

    return (
      <Button {...{ onClick, variant: 'secondary' }}>
        {isAuthorized() ? t('authBackButtonLabel') : t('unauthBackButtonLabel')}
      </Button>
    )
  },
)
